'use client';
import React from 'react';
import PropTypes from 'prop-types';
import { costFormatter } from '@format/currency';
import { ResponsiveImage } from '@web/molecules';
import { Heading, PillText } from '@web/atoms';
import { Modal } from '../Modal';
import {
  StyledMealPrepModal,
  SectionContent,
  Name,
  Description,
  DisplayedPrice,
  StrikeThroughPrice,
  SectionHeader,
  PricesContainer,
  Section,
  ModalContent,
} from './styles';

const formatPrice = price => {
  if (typeof price === 'string' && price.startsWith('$')) {
    return price;
  }
  if (price == null || price === '' || isNaN(price)) {
    return '';
  }

  const parsedPrice = parseFloat(price);

  if (isNaN(parsedPrice)) {
    return '';
  }

  return costFormatter(parsedPrice);
};

export const MealPrepModal = ({ mealPrepTypes, onClickClose, shown }) => {
  return (
    <Modal
      shown={shown}
      onCloseModal={onClickClose}
      mobileFullScreen={false}
      ariaLabel="Full meal prep modal"
    >
      <StyledMealPrepModal>
        <Heading
          headingLevel="h3"
          position="flex-start"
          typography="heading3"
          backgroundColor="background.lightest"
          headingText="Plans & Pricing"
        />
        <ModalContent>
          {mealPrepTypes.map((prepType, index) => {
            const pricingInfo = prepType.pricingInfo;
            return (
              <Section key={index}>
                <SectionContent>
                  <SectionHeader>
                    <ResponsiveImage
                      src={prepType.img.src}
                      alt={prepType.img.alt}
                      width={160}
                      height={75}
                    />
                    {prepType.badge && (
                      <PillText
                        text={prepType.badge}
                        variant="kale"
                        size="small"
                      />
                    )}
                  </SectionHeader>
                  <Name as={prepType.level}>{prepType.title}</Name>
                  {pricingInfo && (
                    <>
                      <PricesContainer>
                        {'From '}
                        <StrikeThroughPrice>
                          {formatPrice(pricingInfo.price)}
                        </StrikeThroughPrice>
                        <DisplayedPrice>
                          {formatPrice(pricingInfo.discount)}/
                          {pricingInfo.period}
                        </DisplayedPrice>
                      </PricesContainer>
                    </>
                  )}
                  <Description>{prepType.description}</Description>
                </SectionContent>
              </Section>
            );
          })}
        </ModalContent>
      </StyledMealPrepModal>
    </Modal>
  );
};

MealPrepModal.displayName = 'MealPrepModal';

MealPrepModal.propTypes = {
  mealPrepTypes: PropTypes.array,
  shown: PropTypes.bool,
  onClickClose: PropTypes.func,
};
